import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import MaterialModal from "../../app/material-modal";
import { inputCommonStyle } from "../../../util/admin/cssCommonStyle";
import { useFormik } from "formik";
import { useKeycloak } from "@react-keycloak/web";
import { toast } from "sonner";
import { useAtom } from "jotai";
import { useGetCanvasLayout } from "../../../tanstackQuery/queries/canvas";
import { CreateGroupData } from "../../../tanstackQuery/queries/superAdmin/group/type";
import { useCreateNewGroup } from "../../../tanstackQuery/queries/superAdmin/group";
import { useQueryClient } from "@tanstack/react-query";
import { SAdminBaseAtom } from "../../../stores/jotai/super-admin/superAdminBase";
interface FormValues {
  name: string;
  canvasType: string;
}
const validate = (values: FormValues) => {
  const errors: Partial<FormValues> = {};
  if (!values.name) {
    errors.name = "Required";
  }
  return errors;
};
const AddTeamModal = ({ open, handleClose, parentGroupID }) => {
  const { keycloak } = useKeycloak();
  const [sAdminBase,]=useAtom(SAdminBaseAtom);
  const client = useQueryClient();

  const {
    mutateAsync: createTeam,
    isPending,
    isSuccess,
  } = useCreateNewGroup(
    { accessToken: keycloak?.token },
    {
      onSuccess: () => {
        client.invalidateQueries({ queryKey: ["orgtree"] });
        handleClose();
      },
    }
  );

  const { data: canvasLayoutData, isLoading: isLayoutLoading } = useGetCanvasLayout({ accessToken: keycloak.token });
  const canvasType = canvasLayoutData?.map((type) => type.name);

  const formik = useFormik({
    initialValues: {
      canvasType: canvasType ? canvasType[0] : "",
      name: "",
    },
    validate,
    onSubmit: (values) => {
      handleSumitNewTeam(values);
    },
  });
  const handleSumitNewTeam = async (values) => {
    const newTeamData: CreateGroupData = {
      name: values.name,
      orgID: sAdminBase?.selectedOrg?.orgID,
      groupType: "Team",
      canvasType: values.canvasType,
      parentGroupID: parentGroupID === "root" ? "root" : parentGroupID,
    };

    try {
      await createTeam(newTeamData);
      if (isSuccess) {
        toast.success("New Team created successfully!");
        formik.resetForm();
        handleClose();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to create Team.");
    }
  };
  return (
    <MaterialModal
      open={open}
      handleDialogClose={handleClose}
      styleOverrides={{
        container: {
          "& .MuiDialog-paper": {
            minHeight: "200px",
            minWidth: "500px",
            ".MuiDialogContent-root": {
              overflow: "auto",
            },
          },
        },
      }}
      title="Create Team"
    >
      <form onSubmit={formik.handleSubmit}>
        <Stack direction="column" justifyContent="space-around">
          <Stack direction="column" justifyContent="center">
            <Stack direction="row" alignItems="center">
              <Box sx={{ flexBasis: "40%" }}>
                <Typography sx={{ fontWeight: "bold" }}> Team Name*</Typography>
              </Box>
              <Box sx={{ flexBasis: "60%" }}>
                <TextField
                  name="name"
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  fullWidth
                  sx={inputCommonStyle}
                  error={formik.submitCount > 0 && Boolean(formik.errors.name)}
                  helperText={formik.submitCount > 0 && formik.errors.name}
                />
              </Box>
            </Stack>
          </Stack>

          <Stack direction="column" justifyContent="center" my={2}>
            <Stack direction="row" alignItems="center">
              <Box sx={{ flexBasis: "40%" }}>
                <Typography sx={{ fontWeight: "bold" }}> Canvas</Typography>
              </Box>
              <Box sx={{ flexBasis: "60%" }}>
                <FormControl sx={{ minWidth: 270, ...inputCommonStyle }}>
                  <Select
                    name="canvasType"
                    size="small"
                    value={formik.values.canvasType}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {canvasType?.map((name) => (
                      <MenuItem value={name}>{name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Stack>
          </Stack>
        </Stack>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button variant="outlined" onClick={() => handleClose()}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isPending}
            endIcon={isPending ? <CircularProgress size={16} /> : null}
          >
            create
          </Button>
        </Box>
      </form>
    </MaterialModal>
  );
};

export default AddTeamModal;
